import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './components/App'

export let startPaymentInputForm = () => {
  const root = createRoot(document.getElementById('new_payment_button'))
  root.render(<App />)
}
